import type { IResponseResult, IRequestOptions } from 'models/api.model'
import { RequestMethod } from 'root-constants'
import { ApiService } from 'services/api.service'

export interface ILearnWorldsSsoLinkResponse {
  url: string
  learnworlds_user_id: string
}

export interface ILearnWorldsEmailInitResponse {
  token: string
}

export class LearnWorldsApi {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  getLearnWorldsSsoLink({
    firebaseIdToken,
    leadId,
    redirectPath,
  }: {
    firebaseIdToken: string
    leadId?: string
    redirectPath?: string
  }): Promise<IResponseResult<ILearnWorldsSsoLinkResponse>> {
    const options: IRequestOptions = {
      method: RequestMethod.POST,
      headers: new Headers({
        Authorization: `Bearer ${firebaseIdToken}`,
      }),
      body: {
        ...(leadId && { lead_id: leadId }),
        ...(redirectPath && { redirect_path: redirectPath }),
      },
      credentials: 'omit',
    }

    return this.api.makeRequest<ILearnWorldsSsoLinkResponse>(
      'api/v1/learnworlds/sso-link',
      options,
    )
  }

  initLearnWorldsEmail({
    firebaseIdToken,
    leadId,
  }: {
    firebaseIdToken: string
    leadId: string
  }): Promise<IResponseResult<ILearnWorldsEmailInitResponse>> {
    const options: IRequestOptions = {
      method: RequestMethod.POST,
      headers: new Headers({
        Authorization: `Bearer ${firebaseIdToken}`,
      }),
      body: { lead_id: leadId },
      credentials: 'omit',
    }

    return this.api.makeRequest<ILearnWorldsEmailInitResponse>(
      'api/v1/learnworlds/email/init',
      options,
    )
  }
}
